/**
 * Servicio del módulo Leads → analytics-api.js (JSONP / GAS).
 * Los componentes no llaman JSONP directamente.
 * @module-isolated analytics-leads
 */
import {
  fetchSalesAnalytics,
  syncKommoLeads,
  fetchStageConfig,
  saveStageConfig
} from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';
import { normalizeLeadsPayload } from '../utils/normalize-leads.js';

/**
 * @param {{ dateFrom:string, dateTo:string, sellerId?:string, pipelineId?:string, originTags?:string[] }} filters
 */
export async function loadLeadsAnalytics(filters) {
  const token = await getIdToken(false);
  const raw = await fetchSalesAnalytics(filters, token);
  return normalizeLeadsPayload(raw);
}

/**
 * Sync full Kommo → planilla (escritura; requiere Turnstile en GAS).
 * @param {{ turnstileToken: string, tipo?: string }} opts
 */
export async function syncLeadsFromSource(opts) {
  const token = await getIdToken(false);
  return syncKommoLeads(token, {
    tipo: (opts && opts.tipo) || 'full',
    turnstileToken: (opts && opts.turnstileToken) || ''
  });
}

export async function loadLeadsStageConfig(opts) {
  const token = await getIdToken(false);
  return fetchStageConfig(token, opts);
}

export async function persistLeadsStageConfig(stages, opts) {
  const token = await getIdToken(false);
  return saveStageConfig(stages, token, opts);
}
